<template>
    <b-modal id="signing-modal" size="xl" no-close-on-esc no-close-on-backdrop>
        <template #modal-title>
            <h5 class="modal-title">Firmar certificado <small>(Total de páginas: {{ fileToSign.totalPages }})</small></h5>
        </template>
        <b-row class="mb-2">
            <b-col cols="12" md="4">
                <label>Signatarios</label>
            </b-col>
            <b-col cols="12" md="4">
                <label>Páginas a firmar</label>
            </b-col>
            <b-col cols="12" md="4">
                <label>Páginas a firmar (Horizontal)</label>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col cols="12" md="4">
                <v-select label="name" :options="signatories" placeholder="Signatario 1" @search="getSignatories"
                          @search:focus="getSignatories" :filterable="false" v-model="signingForm.signer1">
                    <template slot="no-options">Sin resultados.</template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">{{ option.name }}</div>
                        <div class="d-center" v-if="option.email">{{ option.email }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">{{ option.name }}</div>
                    </template>
                </v-select>
                <div v-if="signingForm.errors.signer1" class="invalid-feedback d-block" role="alert">
                    Selecciona al signatario 1
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group>
                    <b-form-input v-model="signingForm.signer1Pages" autocomplete="false"
                                  placeholder="Páginas (Ej: 1,2,4-8,10,11)"></b-form-input>
                    <div v-if="signingForm.errors.signer1Pages.emptyPages" class="invalid-feedback d-block" role="alert">
                        Ingresa el número de las páginas a firmar
                    </div>
                    <div v-if="signingForm.errors.signer1Pages.pagesOutOfLimit" class="invalid-feedback d-block"
                         role="alert">
                        El número de páginas a firmar es mayor al total de páginas del certificado
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group>
                    <b-form-input v-model="signingForm.signer1HorizontalPages" autocomplete="false"
                                  placeholder="Páginas (Ej: 1,2,4-8,10,11)"></b-form-input>
                    <div v-if="signingForm.errors.signer1Pages.emptyPages" class="invalid-feedback d-block" role="alert">
                        Ingresa el número de las páginas a firmar
                    </div>
                    <div v-if="signingForm.errors.signer1Pages.pagesOutOfLimitHorizontal" class="invalid-feedback d-block"
                         role="alert">
                        El número de páginas a firmar es mayor al total de páginas del certificado
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col cols="12" md="4">
                <v-select label="name" :options="signatories" placeholder="Signatario 2" @search="getSignatories"
                          @search:focus="getSignatories" :filterable="false" v-model="signingForm.signer2"
                          :disabled="!signingForm.signer1">
                    <template slot="no-options">Sin resultados.</template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">{{ option.name }}</div>
                        <div class="d-center" v-if="option.email">{{ option.email }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">{{ option.name }}</div>
                    </template>
                </v-select>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group>
                    <b-form-input v-model="signingForm.signer2Pages" autocomplete="false"
                                  placeholder="Páginas (Ej: 1,2,4-8,10,11)" :disabled="!signingForm.signer1"></b-form-input>
                    <div v-if="signingForm.errors.signer2Pages.emptyPages" class="invalid-feedback d-block" role="alert">
                        Ingresa el número de las páginas a firmar
                    </div>
                    <div v-if="signingForm.errors.signer2Pages.pagesOutOfLimit" class="invalid-feedback d-block"
                         role="alert">
                        El número de páginas a firmar es mayor al total de páginas del certificado
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group>
                    <b-form-input v-model="signingForm.signer2HorizontalPages" autocomplete="false"
                                  placeholder="Páginas (Ej: 1,2,4-8,10,11)" :disabled="!signingForm.signer1"></b-form-input>
                    <div v-if="signingForm.errors.signer2Pages.emptyPages" class="invalid-feedback d-block" role="alert">
                        Ingresa el número de las páginas a firmar
                    </div>
                    <div v-if="signingForm.errors.signer2Pages.pagesOutOfLimitHorizontal" class="invalid-feedback d-block"
                         role="alert">
                        El número de páginas a firmar es mayor al total de páginas del certificado
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col cols="12" md="4">
                <v-select label="name" :options="signatories" placeholder="Signatario 3" @search="getSignatories"
                          @search:focus="getSignatories" :filterable="false" v-model="signingForm.signer3"
                          :disabled="!signingForm.signer2">
                    <template slot="no-options">Sin resultados.</template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">{{ option.name }}</div>
                        <div class="d-center" v-if="option.email">{{ option.email }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">{{ option.name }}</div>
                    </template>
                </v-select>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group>
                    <b-form-input v-model="signingForm.signer3Pages" autocomplete="false"
                                  placeholder="Páginas (Ej: 1,2,4-8,10,11)" :disabled="!signingForm.signer2"></b-form-input>
                    <div v-if="signingForm.errors.signer3Pages.emptyPages" class="invalid-feedback d-block" role="alert">
                        Ingresa el número de las páginas a firmar
                    </div>
                    <div v-if="signingForm.errors.signer3Pages.pagesOutOfLimit" class="invalid-feedback d-block"
                         role="alert">
                        El número de páginas a firmar es mayor al total de páginas del certificado
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group>
                    <b-form-input v-model="signingForm.signer3HorizontalPages" autocomplete="false"
                                  placeholder="Páginas (Ej: 1,2,4-8,10,11)" :disabled="!signingForm.signer2"></b-form-input>
                    <div v-if="signingForm.errors.signer3Pages.emptyPages" class="invalid-feedback d-block" role="alert">
                        Ingresa el número de las páginas a firmar
                    </div>
                    <div v-if="signingForm.errors.signer3Pages.pagesOutOfLimitHorizontal" class="invalid-feedback d-block"
                         role="alert">
                        El número de páginas a firmar es mayor al total de páginas del certificado
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col cols="12" md="4">
                <v-select label="name" :options="signatories" placeholder="Signatario 4" @search="getSignatories"
                          @search:focus="getSignatories" :filterable="false" v-model="signingForm.signer4"
                          :disabled="!signingForm.signer3">
                    <template slot="no-options">Sin resultados.</template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">{{ option.name }}</div>
                        <div class="d-center" v-if="option.email">{{ option.email }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">{{ option.name }}</div>
                    </template>
                </v-select>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group>
                    <b-form-input v-model="signingForm.signer4Pages" autocomplete="false"
                                  placeholder="Páginas (Ej: 1,2,4-8,10,11)" :disabled="!signingForm.signer3"></b-form-input>
                    <div v-if="signingForm.errors.signer4Pages.emptyPages" class="invalid-feedback d-block" role="alert">
                        Ingresa el número de las páginas a firmar
                    </div>
                    <div v-if="signingForm.errors.signer4Pages.pagesOutOfLimit" class="invalid-feedback d-block"
                         role="alert">
                        El número de páginas a firmar es mayor al total de páginas del certificado
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group>
                    <b-form-input v-model="signingForm.signer4HorizontalPages" autocomplete="false"
                                  placeholder="Páginas (Ej: 1,2,4-8,10,11)" :disabled="!signingForm.signer3"></b-form-input>
                    <div v-if="signingForm.errors.signer4Pages.emptyPages" class="invalid-feedback d-block" role="alert">
                        Ingresa el número de las páginas a firmar
                    </div>
                    <div v-if="signingForm.errors.signer4Pages.pagesOutOfLimitHorizontal" class="invalid-feedback d-block"
                         role="alert">
                        El número de páginas a firmar es mayor al total de páginas del certificado
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col cols="12" md="4">
                <v-select label="name" :options="signatories" placeholder="Signatario 5" @search="getSignatories"
                          @search:focus="getSignatories" :filterable="false" v-model="signingForm.signer5"
                          :disabled="!signingForm.signer4">
                    <template slot="no-options">Sin resultados.</template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">{{ option.name }}</div>
                        <div class="d-center" v-if="option.email">{{ option.email }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">{{ option.name }}</div>
                    </template>
                </v-select>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group>
                    <b-form-input v-model="signingForm.signer5Pages" autocomplete="false"
                                  placeholder="Páginas (Ej: 1,2,4-8,10,11)" :disabled="!signingForm.signer4"></b-form-input>
                    <div v-if="signingForm.errors.signer5Pages.emptyPages" class="invalid-feedback d-block" role="alert">
                        Ingresa el número de las páginas a firmar
                    </div>
                    <div v-if="signingForm.errors.signer5Pages.pagesOutOfLimit" class="invalid-feedback d-block"
                         role="alert">
                        El número de páginas a firmar es mayor al total de páginas del certificado
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group>
                    <b-form-input v-model="signingForm.signer5HorizontalPages" autocomplete="false"
                                  placeholder="Páginas (Ej: 1,2,4-8,10,11)" :disabled="!signingForm.signer4"></b-form-input>
                    <div v-if="signingForm.errors.signer5Pages.emptyPages" class="invalid-feedback d-block" role="alert">
                        Ingresa el número de las páginas a firmar
                    </div>
                    <div v-if="signingForm.errors.signer5Pages.pagesOutOfLimitHorizontal" class="invalid-feedback d-block"
                         role="alert">
                        El número de páginas a firmar es mayor al total de páginas del certificado
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
        <template #modal-footer="{ cancel }">
            <div>
                <b-button variant="secondary" @click="cancel()">
                    <font-awesome-icon icon="times"></font-awesome-icon> Cancelar
                </b-button>
                <b-button variant="primary" class="ml-2" @click="signFile">
                    <font-awesome-icon icon="signature"></font-awesome-icon> Firmar
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { userListUrl, signedDocumentUrl } from '@/js/routes';
import * as constants from '@/js/constants';

export default {
    name: 'SigningModalOsamex',
    props: {
        modalPublicationItemId: Number,
        fileToSign: Object
    },
    data() {
        return {
            signatories: [],
            signingForm: {
                fileId: 0,
                publicationItemId: 0,
                signer1: null,
                signer1Pages: '',
                signer1HorizontalPages: '',
                signer2: null,
                signer2Pages: '',
                signer2HorizontalPages: '',
                signer3: null,
                signer3Pages: '',
                signer3HorizontalPages: '',
                signer4: null,
                signer4Pages: '',
                signer4HorizontalPages: '',
                signer5: null,
                signer5Pages: '',
                signer5HorizontalPages: '',
                errors: {
                    signer1: false,
                    signer1Pages: {
                        emptyPages: false,
                        pagesOutOfLimit: false,
                        pagesOutOfLimitHorizontal: false
                    },
                    signer2Pages: {
                        emptyPages: false,
                        pagesOutOfLimit: false,
                        pagesOutOfLimitHorizontal: false
                    },
                    signer3Pages: {
                        emptyPages: false,
                        pagesOutOfLimit: false,
                        pagesOutOfLimitHorizontal: false
                    },
                    signer4Pages: {
                        emptyPages: false,
                        pagesOutOfLimit: false,
                        pagesOutOfLimitHorizontal: false
                    },
                    signer5Pages: {
                        emptyPages: false,
                        pagesOutOfLimit: false,
                        pagesOutOfLimitHorizontal: false
                    }
                },
                selectedSigners: [],
                pages: [],
                horizontalPages: []
            },
            files: []
        }
    },
    methods: {
        getSignatories(search = '', loading = null) {
            if (loading) {
                loading(true);
            }

            this.axios.get(userListUrl(), {
                params: {
                    searchWord: search,
                    application: constants.BACK_OFFICE_USER,
                    signatories: true,
                    selectedSigners: this.selectedSigners
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.signatories = response.data.users;
                } else {
                    this.signatories = [];
                }
            }).catch(() => {
                this.signatories = [];
            }).finally(() =>  {
                if (loading) {
                    loading(false);
                }
            });
        },
        validateSigningForm() {
            let signer1Pages = this.signingForm.signer1Pages.replace(/[^0-9$,-]/g, '');
            let signer2Pages = this.signingForm.signer2Pages.replace(/[^0-9$,-]/g, '');
            let signer3Pages = this.signingForm.signer3Pages.replace(/[^0-9$,-]/g, '');
            let signer4Pages = this.signingForm.signer4Pages.replace(/[^0-9$,-]/g, '');
            let signer5Pages = this.signingForm.signer5Pages.replace(/[^0-9$,-]/g, '');
            let signer1HorizontalPages = this.signingForm.signer1HorizontalPages.replace(/[^0-9$,-]/g, '');
            let signer2HorizontalPages = this.signingForm.signer2HorizontalPages.replace(/[^0-9$,-]/g, '');
            let signer3HorizontalPages = this.signingForm.signer3HorizontalPages.replace(/[^0-9$,-]/g, '');
            let signer4HorizontalPages = this.signingForm.signer4HorizontalPages.replace(/[^0-9$,-]/g, '');
            let signer5HorizontalPages = this.signingForm.signer5HorizontalPages.replace(/[^0-9$,-]/g, '');

            this.signingForm.errors.signer1 = !this.signingForm.signer1;
            this.signingForm.errors.signer1Pages.emptyPages = signer1Pages === '' && signer1HorizontalPages === '';
            this.signingForm.errors.signer2Pages.emptyPages = this.signingForm.signer2 && signer2Pages === '' &&
                signer2HorizontalPages === '';
            this.signingForm.errors.signer3Pages.emptyPages = this.signingForm.signer3 && signer3Pages === '' &&
                signer3HorizontalPages === '';
            this.signingForm.errors.signer4Pages.emptyPages = this.signingForm.signer4 && signer4Pages === '' &&
                signer4HorizontalPages === '';
            this.signingForm.errors.signer5Pages.emptyPages = this.signingForm.signer5 && signer5Pages === '' &&
                signer5HorizontalPages === '';

            return this.signingForm.errors.signer1 || this.signingForm.errors.signer1Pages.emptyPages ||
                this.signingForm.errors.signer2Pages.emptyPages || this.signingForm.errors.signer3Pages.emptyPages ||
                this.signingForm.errors.signer4Pages.emptyPages || this.signingForm.errors.signer5Pages.emptyPages;
        },
        signFile() {
            if (!this.validateSigningForm()) {
                let totalPages = this.fileToSign.totalPages;
                let signer1PagesArray = this.signingForm.signer1Pages.replace(/[^0-9$,-]/g, '')
                    .split(',').filter(i => i !== '');
                let signer1HorizontalPagesArray = this.signingForm.signer1HorizontalPages.replace(/[^0-9$,-]/g, '')
                    .split(',').filter(i => i !== '');
                let signer2PagesArray = [];
                let signer2HorizontalPagesArray = [];
                let signer3PagesArray = [];
                let signer3HorizontalPagesArray = [];
                let signer4PagesArray = [];
                let signer4HorizontalPagesArray = [];
                let signer5PagesArray = [];
                let signer5HorizontalPagesArray = [];

                this.signingForm.errors.signer1Pages.pagesOutOfLimit = signer1PagesArray[signer1PagesArray.length - 1] > totalPages;
                this.signingForm.errors.signer1Pages.pagesOutOfLimitHorizontal = signer1HorizontalPagesArray[signer1HorizontalPagesArray.length - 1] > totalPages;
                this.signingForm.errors.signer1Pages.emptyPages = signer1PagesArray.length <= 0 || signer1PagesArray.some(page => isNaN(parseInt(page)));

                if (this.signingForm.signer2) {
                    signer2PagesArray = this.signingForm.signer2Pages.replace(/[^0-9$,-]/g, '')
                        .split(',').filter(i => i !== '');
                    signer2HorizontalPagesArray = this.signingForm.signer2HorizontalPages.replace(/[^0-9$,-]/g, '')
                        .split(',').filter(i => i !== '');

                    this.signingForm.errors.signer2Pages.pagesOutOfLimit = signer2PagesArray[signer2PagesArray.length - 1] > totalPages;
                    this.signingForm.errors.signer2Pages.pagesOutOfLimitHorizontal = signer2HorizontalPagesArray[signer2HorizontalPagesArray.length - 1] > totalPages;
                    this.signingForm.errors.signer2Pages.emptyPages = signer2PagesArray.length <= 0 || signer2PagesArray.some(page => isNaN(parseInt(page)));
                }

                if (this.signingForm.signer3) {
                    signer3PagesArray = this.signingForm.signer3Pages.replace(/[^0-9$,-]/g, '')
                        .split(',').filter(i => i !== '');
                    signer3HorizontalPagesArray = this.signingForm.signer3HorizontalPages.replace(/[^0-9$,-]/g, '')
                        .split(',').filter(i => i !== '');

                    this.signingForm.errors.signer3Pages.pagesOutOfLimit = signer3PagesArray[signer3PagesArray.length - 1] > totalPages;
                    this.signingForm.errors.signer3Pages.pagesOutOfLimitHorizontal = signer3HorizontalPagesArray[signer3HorizontalPagesArray.length - 1] > totalPages;
                    this.signingForm.errors.signer3Pages.emptyPages = signer3PagesArray.length <= 0 || signer3PagesArray.some(page => isNaN(parseInt(page)));
                }

                if (this.signingForm.signer4) {
                    signer4PagesArray = this.signingForm.signer4Pages.replace(/[^0-9$,-]/g, '')
                        .split(',').filter(i => i !== '');
                    signer4HorizontalPagesArray = this.signingForm.signer4HorizontalPages.replace(/[^0-9$,-]/g, '')
                        .split(',').filter(i => i !== '');

                    this.signingForm.errors.signer4Pages.pagesOutOfLimit = signer4PagesArray[signer4PagesArray.length - 1] > totalPages;
                    this.signingForm.errors.signer4Pages.pagesOutOfLimitHorizontal = signer4HorizontalPagesArray[signer4HorizontalPagesArray.length - 1] > totalPages;
                    this.signingForm.errors.signer4Pages.emptyPages = signer4PagesArray.length <= 0 || signer4PagesArray.some(page => isNaN(parseInt(page)));
                }

                if (this.signingForm.signer5) {
                    signer5PagesArray = this.signingForm.signer5Pages.replace(/[^0-9$,-]/g, '')
                        .split(',').filter(i => i !== '');
                    signer5HorizontalPagesArray = this.signingForm.signer5HorizontalPages.replace(/[^0-9$,-]/g, '')
                        .split(',').filter(i => i !== '');

                    this.signingForm.errors.signer5Pages.pagesOutOfLimit = signer5PagesArray[signer5PagesArray.length - 1] > totalPages;
                    this.signingForm.errors.signer5Pages.pagesOutOfLimitHorizontal = signer5HorizontalPagesArray[signer5HorizontalPagesArray.length - 1] > totalPages;
                    this.signingForm.errors.signer5Pages.emptyPages = signer5PagesArray.length <= 0 || signer5PagesArray.some(page => isNaN(parseInt(page)));
                }

                if (!this.signingForm.errors.signer1Pages.pagesOutOfLimit && !this.signingForm.errors.signer1Pages.pagesOutOfLimitHorizontal &&
                    !this.signingForm.errors.signer2Pages.pagesOutOfLimit && !this.signingForm.errors.signer2Pages.pagesOutOfLimitHorizontal &&
                    !this.signingForm.errors.signer3Pages.pagesOutOfLimit && !this.signingForm.errors.signer3Pages.pagesOutOfLimitHorizontal &&
                    !this.signingForm.errors.signer4Pages.pagesOutOfLimit && !this.signingForm.errors.signer4Pages.pagesOutOfLimitHorizontal &&
                    !this.signingForm.errors.signer5Pages.pagesOutOfLimit && !this.signingForm.errors.signer5Pages.pagesOutOfLimitHorizontal) {

                    this.$swal({
                        title: `¿Estás seguro de firmar el certificado?`,
                        icon: 'question'
                    }).then(result => {
                        if (result.value) {
                            signer1PagesArray.forEach(pages => {
                                if (!pages.includes('-')) {
                                    if (!this.signingForm.pages.includes(parseInt(pages))) {
                                        this.signingForm.pages.push(parseInt(pages));
                                    }
                                } else {
                                    let pagesSplit = pages.split('-');

                                    for (let i = parseInt(pagesSplit[0]); i <= parseInt(pagesSplit[1]); i++) {
                                        if (!this.signingForm.pages.includes(i)) {
                                            this.signingForm.pages.push(i);
                                        }
                                    }
                                }
                            });

                            signer1HorizontalPagesArray.forEach(pages => {
                                if (!pages.includes('-')) {
                                    if (!this.signingForm.horizontalPages.includes(parseInt(pages))) {
                                        this.signingForm.horizontalPages.push(parseInt(pages));
                                    }
                                } else {
                                    let pagesSplit = pages.split('-');

                                    for (let i = parseInt(pagesSplit[0]); i <= parseInt(pagesSplit[1]); i++) {
                                        if (!this.signingForm.horizontalPages.includes(i)) {
                                            this.signingForm.horizontalPages.push(i);
                                        }
                                    }
                                }
                            });

                            this.signingForm.selectedSigners.push({
                                id: this.signingForm.signer1.id,
                                position: 1,
                                pages: this.signingForm.pages,
                                horizontalPages: this.signingForm.horizontalPages
                            });

                            if (signer2PagesArray.length > 0 || signer2HorizontalPagesArray.length > 0) {
                                this.signingForm.pages = [];
                                this.signingForm.horizontalPages = [];

                                signer2PagesArray.forEach(pages => {
                                    if (!pages.includes('-')) {
                                        if (!this.signingForm.pages.includes(parseInt(pages))) {
                                            this.signingForm.pages.push(parseInt(pages));
                                        }
                                    } else {
                                        let pagesSplit = pages.split('-');

                                        for (let i = parseInt(pagesSplit[0]); i <= parseInt(pagesSplit[1]); i++) {
                                            if (!this.signingForm.pages.includes(i)) {
                                                this.signingForm.pages.push(i);
                                            }
                                        }
                                    }
                                });

                                signer2HorizontalPagesArray.forEach(pages => {
                                    if (!pages.includes('-')) {
                                        if (!this.signingForm.horizontalPages.includes(parseInt(pages))) {
                                            this.signingForm.horizontalPages.push(parseInt(pages));
                                        }
                                    } else {
                                        let pagesSplit = pages.split('-');

                                        for (let i = parseInt(pagesSplit[0]); i <= parseInt(pagesSplit[1]); i++) {
                                            if (!this.signingForm.horizontalPages.includes(i)) {
                                                this.signingForm.horizontalPages.push(i);
                                            }
                                        }
                                    }
                                });

                                this.signingForm.selectedSigners.push({
                                    id: this.signingForm.signer2.id,
                                    position: 2,
                                    pages: this.signingForm.pages,
                                    horizontalPages: this.signingForm.horizontalPages
                                });
                            }

                            if (signer3PagesArray.length > 0 || signer3HorizontalPagesArray.length > 0) {
                                this.signingForm.pages = [];
                                this.signingForm.horizontalPages = [];

                                signer3PagesArray.forEach(pages => {
                                    if (!pages.includes('-')) {
                                        if (!this.signingForm.pages.includes(parseInt(pages))) {
                                            this.signingForm.pages.push(parseInt(pages));
                                        }
                                    } else {
                                        let pagesSplit = pages.split('-');

                                        for (let i = parseInt(pagesSplit[0]); i <= parseInt(pagesSplit[1]); i++) {
                                            if (!this.signingForm.pages.includes(i)) {
                                                this.signingForm.pages.push(i);
                                            }
                                        }
                                    }
                                });

                                signer3HorizontalPagesArray.forEach(pages => {
                                    if (!pages.includes('-')) {
                                        if (!this.signingForm.horizontalPages.includes(parseInt(pages))) {
                                            this.signingForm.horizontalPages.push(parseInt(pages));
                                        }
                                    } else {
                                        let pagesSplit = pages.split('-');

                                        for (let i = parseInt(pagesSplit[0]); i <= parseInt(pagesSplit[1]); i++) {
                                            if (!this.signingForm.horizontalPages.includes(i)) {
                                                this.signingForm.horizontalPages.push(i);
                                            }
                                        }
                                    }
                                });

                                this.signingForm.selectedSigners.push({
                                    id: this.signingForm.signer3.id,
                                    position: 3,
                                    pages: this.signingForm.pages,
                                    horizontalPages: this.signingForm.horizontalPages
                                });
                            }

                            if (signer4PagesArray.length > 0 || signer4HorizontalPagesArray.length > 0) {
                                this.signingForm.pages = [];
                                this.signingForm.horizontalPages = [];

                                signer4PagesArray.forEach(pages => {
                                    if (!pages.includes('-')) {
                                        if (!this.signingForm.pages.includes(parseInt(pages))) {
                                            this.signingForm.pages.push(parseInt(pages));
                                        }
                                    } else {
                                        let pagesSplit = pages.split('-');

                                        for (let i = parseInt(pagesSplit[0]); i <= parseInt(pagesSplit[1]); i++) {
                                            if (!this.signingForm.pages.includes(i)) {
                                                this.signingForm.pages.push(i);
                                            }
                                        }
                                    }
                                });

                                signer4HorizontalPagesArray.forEach(pages => {
                                    if (!pages.includes('-')) {
                                        if (!this.signingForm.horizontalPages.includes(parseInt(pages))) {
                                            this.signingForm.horizontalPages.push(parseInt(pages));
                                        }
                                    } else {
                                        let pagesSplit = pages.split('-');

                                        for (let i = parseInt(pagesSplit[0]); i <= parseInt(pagesSplit[1]); i++) {
                                            if (!this.signingForm.horizontalPages.includes(i)) {
                                                this.signingForm.horizontalPages.push(i);
                                            }
                                        }
                                    }
                                });

                                this.signingForm.selectedSigners.push({
                                    id: this.signingForm.signer4.id,
                                    position: 4,
                                    pages: this.signingForm.pages,
                                    horizontalPages: this.signingForm.horizontalPages
                                });
                            }

                            if (signer5PagesArray.length > 0 || signer5HorizontalPagesArray.length > 0) {
                                this.signingForm.pages = [];
                                this.signingForm.horizontalPages = [];

                                signer5PagesArray.forEach(pages => {
                                    if (!pages.includes('-')) {
                                        if (!this.signingForm.pages.includes(parseInt(pages))) {
                                            this.signingForm.pages.push(parseInt(pages));
                                        }
                                    } else {
                                        let pagesSplit = pages.split('-');

                                        for (let i = parseInt(pagesSplit[0]); i <= parseInt(pagesSplit[1]); i++) {
                                            if (!this.signingForm.pages.includes(i)) {
                                                this.signingForm.pages.push(i);
                                            }
                                        }
                                    }
                                });

                                signer5HorizontalPagesArray.forEach(pages => {
                                    if (!pages.includes('-')) {
                                        if (!this.signingForm.horizontalPages.includes(parseInt(pages))) {
                                            this.signingForm.horizontalPages.push(parseInt(pages));
                                        }
                                    } else {
                                        let pagesSplit = pages.split('-');

                                        for (let i = parseInt(pagesSplit[0]); i <= parseInt(pagesSplit[1]); i++) {
                                            if (!this.signingForm.horizontalPages.includes(i)) {
                                                this.signingForm.horizontalPages.push(i);
                                            }
                                        }
                                    }
                                });

                                this.signingForm.selectedSigners.push({
                                    id: this.signingForm.signer5.id,
                                    position: 5,
                                    pages: this.signingForm.pages,
                                    horizontalPages: this.signingForm.horizontalPages
                                });
                            }

                            this.$emit('show-overlay', true);
                            this.$bvModal.hide('signing-modal');

                            this.axios.post(signedDocumentUrl(), this.signingForm).then(response => {
                                if (response.data.code === constants.CODE_OK) {
                                    this.$root.$bvToast.toast(response.data.message, {
                                        title: 'Firma de certificado',
                                        variant: 'success'
                                    });

                                    this.$emit('update-file-is-signed-status', {
                                        publicationItemId: this.signingForm.publicationItemId,
                                        fileId: this.signingForm.fileId
                                    });
                                } else {
                                    this.$root.$bvToast.toast(response.data.message, {
                                        title: 'Firma de certificado',
                                        variant: 'danger'
                                    });
                                }
                            }).catch(() => {
                                this.$root.$bvToast.toast(constants.DEFAULT_ERROR_MESSAGE, {
                                    title: 'Firma de certificado',
                                    variant: 'danger'
                                });
                            }).finally(() => {
                                this.$emit('show-overlay', false);
                            });
                        }
                    });
                }
            }
        }
    },
    computed: {
        selectedSigners() {
            return [this.signingForm.signer1?.id || 0, this.signingForm.signer2?.id || 0, this.signingForm.signer3?.id || 0,
                this.signingForm.signer4?.id || 0].join(',');
        }
    },
    watch: {
        modalPublicationItemId(val) {
            this.signingForm.publicationItemId = val;
            this.signingForm.fileId = this.fileToSign.id;
            this.signingForm.signer1 = null;
            this.signingForm.signer1Pages = '';
            this.signingForm.signer1HorizontalPages = '';
            this.signingForm.signer2 = null;
            this.signingForm.signer2Pages = '';
            this.signingForm.signer2HorizontalPages = '';
            this.signingForm.signer3 = null;
            this.signingForm.signer3Pages = '';
            this.signingForm.signer3HorizontalPages = '';
            this.signingForm.signer4 = null;
            this.signingForm.signer4Pages = '';
            this.signingForm.signer4HorizontalPages = '';
            this.signingForm.signer5 = null;
            this.signingForm.signer5Pages = '';
            this.signingForm.signer5HorizontalPages = '';
            this.signingForm.errors.signer1 = false;
            this.signingForm.errors.signer1Pages.emptyPages = false;
            this.signingForm.errors.signer2Pages.emptyPages = false;
            this.signingForm.errors.signer3Pages.emptyPages = false;
            this.signingForm.errors.signer4Pages.emptyPages = false;
            this.signingForm.errors.signer5Pages.emptyPages = false;
            this.signingForm.errors.signer1Pages.pagesOutOfLimit = false;
            this.signingForm.errors.signer2Pages.pagesOutOfLimit = false;
            this.signingForm.errors.signer3Pages.pagesOutOfLimit = false;
            this.signingForm.errors.signer4Pages.pagesOutOfLimit = false;
            this.signingForm.errors.signer5Pages.pagesOutOfLimit = false;
            this.signingForm.errors.signer1Pages.pagesOutOfLimitHorizontal = false;
            this.signingForm.errors.signer2Pages.pagesOutOfLimitHorizontal = false;
            this.signingForm.errors.signer3Pages.pagesOutOfLimitHorizontal = false;
            this.signingForm.errors.signer4Pages.pagesOutOfLimitHorizontal = false;
            this.signingForm.errors.signer5Pages.pagesOutOfLimitHorizontal = false;
            this.signingForm.selectedSigners = [];
            this.signingForm.pages = [];
        },
        'signingForm.signer1': {
            handler(signer1) {
                this.signingForm.errors.signer1 = !signer1

                if (!signer1) {
                    this.signingForm.signer2 = null;
                    this.signingForm.signer3 = null;
                    this.signingForm.signer4 = null;
                }
            },
            deep: true
        },
        'signingForm.signer2': {
            handler(signer2) {
                this.signingForm.errors.signer2= !signer2

                if (!signer2) {
                    this.signingForm.signer3 = null;
                    this.signingForm.signer4 = null;
                }
            },
            deep: true
        },
        'signingForm.signer3': {
            handler(signer3) {
                if (!signer3) {
                    this.signingForm.signer4 = null;
                }
            },
            deep: true
        },
        'signingForm.signer1Pages': {
            handler(signer1Pages) {
                this.signingForm.errors.signer1Pages.emptyPages = signer1Pages.replace(/[^0-9$,-]/g, '') === '' &&
                    this.signingForm.signer1HorizontalPages.replace(/[^0-9$,-]/g, '') === '';
            },
            deep: true
        },
        'signingForm.signer2Pages': {
            handler(signer2Pages) {
                this.signingForm.errors.signer2Pages.emptyPages = signer2Pages.replace(/[^0-9$,-]/g, '') === '' &&
                    this.signingForm.signer2HorizontalPages.replace(/[^0-9$,-]/g, '') === '';
            },
            deep: true
        },
        'signingForm.signer3Pages': {
            handler(signer3Pages) {
                this.signingForm.errors.signer3Pages.emptyPages = signer3Pages.replace(/[^0-9$,-]/g, '') === '' &&
                    this.signingForm.signer3HorizontalPages.replace(/[^0-9$,-]/g, '') === '';
            },
            deep: true
        },
        'signingForm.signer4Pages': {
            handler(signer4Pages) {
                this.signingForm.errors.signer4Pages.emptyPages = signer4Pages.replace(/[^0-9$,-]/g, '') === '' &&
                    this.signingForm.signer4HorizontalPages.replace(/[^0-9$,-]/g, '') === '';
            },
            deep: true
        },
        'signingForm.signer5Pages': {
            handler(signer5Pages) {
                this.signingForm.errors.signer5Pages.emptyPages = signer5Pages.replace(/[^0-9$,-]/g, '') === '' &&
                    this.signingForm.signer5HorizontalPages.replace(/[^0-9$,-]/g, '') === '';
            },
            deep: true
        },
        'signingForm.signer1HorizontalPages': {
            handler(signer1HorizontalPages) {
                this.signingForm.errors.signer1Pages.emptyPages = signer1HorizontalPages.replace(/[^0-9$,-]/g, '') === '' &&
                    this.signingForm.signer1Pages.replace(/[^0-9$,-]/g, '') === '';
            },
            deep: true
        },
        'signingForm.signer2HorizontalPages': {
            handler(signer2HorizontalPages) {
                this.signingForm.errors.signer2Pages.emptyPages = signer2HorizontalPages.replace(/[^0-9$,-]/g, '') === '' &&
                    this.signingForm.signer2Pages.replace(/[^0-9$,-]/g, '') === '';
            },
            deep: true
        },
        'signingForm.signer3HorizontalPages': {
            handler(signer3HorizontalPages) {
                this.signingForm.errors.signer3Pages.emptyPages = signer3HorizontalPages.replace(/[^0-9$,-]/g, '') === '' &&
                    this.signingForm.signer3Pages.replace(/[^0-9$,-]/g, '') === '';
            },
            deep: true
        },
        'signingForm.signer4HorizontalPages': {
            handler(signer4HorizontalPages) {
                this.signingForm.errors.signer4Pages.emptyPages = signer4HorizontalPages.replace(/[^0-9$,-]/g, '') === '' &&
                    this.signingForm.signer4Pages.replace(/[^0-9$,-]/g, '') === '';
            },
            deep: true
        },
        'signingForm.signer5HorizontalPages': {
            handler(signer5HorizontalPages) {
                this.signingForm.errors.signer5Pages.emptyPages = signer5HorizontalPages.replace(/[^0-9$,-]/g, '') === '' &&
                    this.signingForm.signer5Pages.replace(/[^0-9$,-]/g, '') === '';
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>